// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const NoteBlankIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'note-blank'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M10 21L10 15.1667C10 14.8572 9.87708 14.5605 9.65829 14.3417C9.4395 14.1229 9.14275 14 8.83333 14H3M3.00001 15C2.99923 15.3169 3.06122 15.6308 3.18239 15.9236C3.30357 16.2164 3.48153 16.4823 3.70601 16.706L7.29401 20.294C7.51768 20.5185 7.78359 20.6964 8.0764 20.8176C8.36921 20.9388 8.68311 21.0008 9.00001 21L19 21C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19L21 5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21072 19.5304 3 19 3L5.00001 3C4.46958 3 3.96087 3.21071 3.5858 3.58579C3.21072 3.96086 3.00001 4.46957 3.00001 5L3.00001 15Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
NoteBlankIcon.displayName = 'NoteBlankIcon'
export { NoteBlankIcon }
